import { Button, Dialog, DialogContent, DialogContentText, DialogTitle, DialogActions, Typography } from '@mui/material';
import React from 'react';
import SendIcon from '@mui/icons-material/Send';

export type AlertInfoPropsType = {
  text: string
  title: string
  isOpen: boolean
  sendComment: () => void
}

export const AlertInfoSendComment = (props: AlertInfoPropsType) => {
  const [open, setOpen] = React.useState(false)
  
  const handleClose = () => {
    setOpen(false);
  };

  const handleCloseOnOK = () => {
    setOpen(false);
  }
  const onSend = () => {
    if(!props.isOpen) {
      props.sendComment()
    } else {
      setOpen(true)
    }
  }

  return (
    <div>
   <Typography >
      <Button onClick={onSend} color='info' endIcon={<SendIcon fontSize='medium' />} >SEND</Button>
   </Typography>
    
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
         {props.title}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
        {props.text}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseOnOK} variant="contained" color="info" autoFocus>
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
